import React from 'react'
import { useTranslation } from 'react-i18next'

import { ColumnAdapter } from '@makyoapp/makyo-common'
import { Column16 } from '@makyoapp/makyo-icon/icon'

import { cn } from '@/lib/cn'

import { ColumnTypeIcon } from './ColumnTypeIcon'

/**
 * handle render of column name for select dropdown options
 */
export function RenderColumn({
  col,
  withStyle = true,
  className,
  width = 16,
  height = 16,
  textClassName,
  iconProps,
  showDetailedInfo = false,
  tableName,
  actionLabel,
}: {
  withStyle?: boolean
  col?: Pick<ColumnAdapter, 'name' | 'id' | 'type'> & { settings?: any }
  className?: string
  width?: number
  height?: number
  textClassName?: string
  iconProps?: React.ComponentPropsWithoutRef<'svg'>
  showDetailedInfo?: boolean
  tableName?: string
  actionLabel?: string
}) {
  const { t } = useTranslation()

  const getDetailedName = () => {
    if (!col) return ''

    if (showDetailedInfo && actionLabel && tableName) {
      return `${actionLabel} -> ${tableName} -> ${col.name}`
    }

    if (showDetailedInfo && actionLabel) {
      return `${actionLabel} -> ${col.name}`
    }

    if (showDetailedInfo && tableName) {
      return `${tableName} -> ${col.name}`
    }

    return col.id === '' ? t(col?.name) : (col?.name ?? '')
  }

  return (
    <RenderColumnCustom
      className={cn(col?.id === '' && 'text-light')}
      textClassName={textClassName}
      name={getDetailedName()}
      icon={
        col?.id === '' || !col?.type ? (
          <Column16 className={cn('shrink-0', iconProps?.className)} />
        ) : (
          <ColumnTypeIcon type={col.type} size={width} className={cn(withStyle && 'shrink-0', iconProps?.className)} />
        )
      }
    />
  )
}

/**
 * handle render of column name for select dropdown options
 */
export function RenderColumnCustom({
  name,
  icon,
  className,
  textClassName,
}: {
  name: string
  icon: React.ReactNode
  className?: string
  textClassName?: string
}) {
  return (
    <div className={cn('flex-c', className)}>
      {icon}
      <span className={textClassName}>{name}</span>
    </div>
  )
}
